import { getImage, getImageURL } from "../../services/ImageService";

export function SectionCard(props) {
    const backgroundImagePath = props.img ? getImageURL(props.img) : null;

    return (
        <div
            className="w-full px-12 lg:px-24 xl:px-60 max-w-[180rem] mx-auto"
            id={props.id ? props.id : ""}
        >
            <div
                className={`scaled-headings text-white w-full overflow-hidden relative rounded-[4rem] md:rounded-[6rem] lg:rounded-[8rem] xl:rounded-[10rem] px-12 lg:px-24 xl:px-40 py-12 md:py-16 lg:py-24 xl:py-32 ${
                    props.className ? props.className : ""
                }`}
            >
                <div className="z-30 flex flex-col gap-16 lg:gap-24">
                    {props.children}
                </div>
                <img
                    className="absolute bottom-0 right-0 w-3/5 z-20 select-none"
                    src={getImage("cards/shade.png")}
                    alt=""
                    draggable={false}
                    loading="lazy"
                />
                <div
                    className={`absolute z-10 block lg:hidden h-[48rem] w-[48rem] top-[-24rem] right-[-17rem] lg:h-[64rem] lg:w-[64rem] lg:top-[-35rem] lg:right-[-22rem] xl:h-[78rem] xl:w-[78rem] xl:top-[-46rem] xl:right-[-30rem] ${
                        props.gradientClassName ? props.gradientClassName : ""
                    }`}
                ></div>
                <div
                    style={{ backgroundImage: backgroundImagePath }}
                    className="absolute bg-center bg-no-repeat bg-cover rounded-full overflow-hidden z-0 h-[48rem] w-[48rem] top-[-30rem] right-[-19rem] lg:h-[64rem] lg:w-[64rem] lg:top-[-42rem] lg:right-[-24rem] xl:h-[78rem] xl:w-[78rem] xl:top-[-52rem] xl:right-[-32rem]"
                ></div>
            </div>
        </div>
    );
}
